import { FC, ReactNode } from 'react'
import { Popover } from 'antd'
import s from './index.module.less'
import { renderTime } from '@/utils/common'
import { type VipType, VIP_TYPE_MAP } from '@/consts/newConsts'

interface VipDetailProps {
  userInfo: any
  children: ReactNode
}

const VipDetail: FC<VipDetailProps> = ({ userInfo, children }) => {
  const vipInfo = userInfo?.vip_info || []

  return (
    <Popover
      placement='bottom'
      title={''}
      classNames={{ root: s.modelPopover }}
      arrow={false}
      align={{ offset: [0, 10] }}
      content={() => (
        <div className={s.popContent} onClick={(e) => e.stopPropagation()}>
          {vipInfo
            .slice()
            .sort((a: any, b: any) => b.vip_type - a.vip_type)
            .map((item: any) => {
              const isVip = item.is_vip
              const vipName = VIP_TYPE_MAP[item.vip_type as VipType]
              const endTime = renderTime(item.vip_end_time * 1000, 'YYYY-M-D')
              if (!isVip) {
                return null
              }
              
              return (
                <div key={item.vip_type} className='vipItem'>
                  {vipName}<span className='timeText'>{endTime}</span>到期
                </div>
              )
            })}
        </div>
      )}>
      {children}
    </Popover>
  )
}

export default VipDetail
